import { homeModule } from './home.module';
import '../../app-ds3/EICDataStream3.HttpInterceptors.js';
//import { environment } from '../../environments/environment';
import { FunctionUnavailableComponent } from '../shared/ui/function-unavailable/function-unavailable.component';








/////////////////////////////////////////

/**
 * This is the login state.  It is activated when the user navigates to /login, or if a unauthenticated
 * user attempts to access a protected state (or substate) which requires authentication. (see routerhooks/requiresAuth.js)
 *
 * It shows a fake login dialog and prompts the user to authenticate.  Once the user authenticates, it then
 * reactivates the state that the user originally came from.
 */
// Obsolete
// const loginState = {
//   parent: 'app',
//   name: 'login',
//   url: '/bff/login',
//   component: 'login',
//   resolve: { returnTo: returnTo }
// };



// const ds3RootState = {
//   name: 'app',
//   abstract: true,
//   url: '/ds3',

//   // Note: abstract still needs a ui-view for its children to populate.
//   // You can simply add it inline here.
//   template: `
//   <table>
//     <tr>
//       <td>hello world</td>
//       <td><ui-view/></td>
//     </tr>
//   </table> `
// };
















/**
 * A resolve function for 'login' state which figures out what state to return to, after a successful login.
 *
 * If the user was initially redirected to login state (due to the requiresAuth redirect), then return the toState/params
 * they were redirected from.  Otherwise, if they transitioned directly, return the fromState/params.  Otherwise
 * return the main "home" state.
 */
returnTo.$inject = ['$transition$'];
function returnTo($transition$): any {
  if ($transition$.redirectedFrom() != null) {
    // The user was redirected to the login state (e.g., via the requiresAuth hook when trying to activate contacts)
    // Return to the original attempted target state (e.g., contacts)
    return $transition$.redirectedFrom().targetState();
  }

  let $state = $transition$.router.stateService;

  // The user was not redirected to the login state; they directly activated the login state somehow.
  // Return them to the state they came from.
  if ($transition$.from().name !== '') {
    return $state.target($transition$.from(), $transition$.params("from"));
  }

  // If the fromState's name is empty, then this was the initial transition. Go to dashboard.
  return $state.target('dashboard');
}

homeModule.config([
  '$stateProvider',
  'APP_META',
  'PRODUCT_IDENTITY',
  'DASHBOARD_CONFIG',
  'NOTIFICATIONS_CONFIG',
  'GEOGRAPHICAL_SUMMARY_CONFIG',
  function ($stateProvider, APP_META, PRODUCT_IDENTITY, DASHBOARD_CONFIG, NOTIFICATIONS_CONFIG, GEOGRAPHICAL_SUMMARY_CONFIG) {

    /**
 * This is the parent state for the entire application.
 *
 * This state's primary purposes are:
 * 1) Shows the outermost chrome (including the navigation and logout for authenticated users)
 * 2) Provide a viewport (ui-view) for a substate to plug into
 */
    const appState = {
      name: 'app',
      redirectTo: 'dashboard',
      component: 'app',
    };


    const envName = APP_META.environment.name;

    const unauthorizedForEnvironmentState = {
      parent: "app",
      name: "unauthorizedForEnvironment",
      url: '/unauthorizedforenvironment',
      controller: ['$scope', function ($scope) { }],
      template: `
<md-card>
  <md-card-header style="background-color:red;padding:0px;">
    <md-card-title style="padding:5px;padding-left:16px;margin:0;">
      <md-card-title-text style="color:white;">
        <h2 style="margin:0;"><i class="glyphicon glyphicon-warning-sign"></i> Unauthorised</h2>
      </md-card-title-text>
    </md-card-title>
  </md-card-header>
  <md-card-content>
    <p>You are not authorised to access the ${envName} environment</p>
    return to <a href='https://eicdatastream.the-eic.com'>live EICDataStream</a>.
    <br>
    <br>
    <p>If you  believe that you are seeing this message in error, please <a href="mailto:membership@the-eic.com?subject=I am unable to access EICDataStream ${envName} environment">contact us</a>.</p>
  </md-card-content>
</md-card>
  `,
    };

    const splashScreenState = {
      parent: "app",
      name: "splashScreen",
      url: '/splashScreen',
      controller: ['$scope', function ($scope) { }],
      template: `
<md-card>
  <md-card-header style="background-color:red;padding:0px;">
    <md-card-title style="padding:5px;padding-left:16px;margin:0;">
      <md-card-title-text style="color:white;">
        <h2 style="margin:0;"><i class="glyphicon glyphicon-warning-sign"></i> Unauthorised</h2>
      </md-card-title-text>
    </md-card-title>
  </md-card-header>
  <md-card-content>
    Splash Screen
  </md-card-content>
</md-card>
  `,
    };

    let dashboardState = {};
    const isEicAssetMap = PRODUCT_IDENTITY.fullName === "EICAssetMap";
    const enableDashboardForEicAssetMap = !!(DASHBOARD_CONFIG && DASHBOARD_CONFIG.enableDashboardForEicAssetMap);
    const enableNewDashboard = !!(DASHBOARD_CONFIG && DASHBOARD_CONFIG.enableNewDashboard);
    const useNewNotifications = !!(NOTIFICATIONS_CONFIG && NOTIFICATIONS_CONFIG.useNewNotifications);

    if (isEicAssetMap && !enableDashboardForEicAssetMap) {
      dashboardState = {
        parent: 'app',
        name: 'dashboard',
        url: '/',
        redirectTo: 'assets.search',
      };
    }
    else if (enableNewDashboard) {
      dashboardState = {
        parent: 'app',
        name: 'dashboard',
        url: '/',
        redirectTo: 'app.dashboardNew',
        data: { requiresAuth: true },
      }
    }
    else {
      dashboardState = {
        parent: 'app',
        name: 'dashboard',
        url: '/',
        templateUrl: "../app-ds3/dashboard/dashboard.partial.html",
        controller: 'DashboardController',
        data: { requiresAuth: true },
      }
    }



    /**
     * This is the 'welcome' state.  It is the default state (as defined by app.js) if no other state
     * can be matched to the URL.
     */
    // This shouldn;t be needed anymore
    // const welcomeState = {
    //   parent: 'app',
    //   name: 'welcome',
    //   url: '/welcome',
    //   component: 'welcome'
    // };


    /**
     * This is a home screen for authenticated users.
     *
     * It shows giant buttons which activate their respective submodules: Messages, Contacts, Preferences
     */
    // This shouldn;t be needed anymore
    // const homeState = {
    //   parent: 'app',
    //   name: 'home',
    //   url: '/home',
    //   component: 'home',
    //   data: { requiresAuth: true }
    // };



    ///////////////////////////////////////////////////////////////////////
    //  search
    ///////////////////////////////////////////////////////////////////////
    const searchState = {
      parent: "app",
      name: "search",
      url: '/search',
      controller: 'SearchController',
      templateUrl: '../app-ds3/search/searchHeader.partial.html',
      resolve: {
        //user: [
        //  '$q', 'oidcManager', function ($q, oidcManager) {
        //    return oidcManager.manager.getUser(); // <-- already a promise
        //  }
        //]
      },
      data: { requiresAuth: true }
    };
    const searchForProjectsState = {
      url: '/searchforprojects',
      name: "search.forProjects",
      controller: 'SearchController',
      templateUrl: '../app-ds3/search/searchHeader.partial.html',
      resolve: {
        //user: [
        //  '$q', 'oidcManager', function ($q, oidcManager) {
        //    return oidcManager.manager.getUser(); // <-- already a promise
        //  }
        //]
      },
      data: { requiresAuth: true }
    };
    const searchForProjectsMobileState = {
      url: '/unavailable',
      name: "unavailable",
      component: FunctionUnavailableComponent,
      params: {
        'module': null,
        'function': null,
        'reason': null
      },
      data: { requiresAuth: true },
      resolve: {
        //user: [
        //  '$q', 'oidcManager', function ($q, oidcManager) {
        //    return oidcManager.manager.getUser(); // <-- already a promise
        //  }
        //]
      }

    };


    const searchForContractAwardsState = {
      url: '/searchforcontractawards',
      name: "search.forContractAwards",
      controller: 'SearchController',
      templateUrl: '../app-ds3/search/searchHeader.partial.html',
      resolve: {
        //user: [
        //  '$q', 'oidcManager', function ($q, oidcManager) {
        //    return oidcManager.manager.getUser(); // <-- already a promise
        //    //return resolveUser("Search", $q, oidcManager);
        //  }
        //]
      },
      data: { requiresAuth: true }
    };

    const searchProjectSummaryState = {
      name: "search.projectSummary",
      url: '/projectSummary/:guid/:name',
      // '/projectsummary/{searchID}{searchName:(?:/[^/]+)?}', causes controller to be double-loaded
      controller: 'ProjectSummaryController',
      templateUrl: function () {
        if (window.innerWidth < 825) {
          return '../app-ds3/search/projectSummary-mobile.partial.html';
        }
        else {
          return '../app-ds3/search/projectSummary.partial.html';
        }
      },
      //"../app-ds3/search/projectSummary.partial.html",
      data: { requiresAuth: true }
    };

    // // Experiment
    // const searchProjectSummaryNamelessState = {
    //   name: "search.projectSummary",
    //   url: '/projectSummary/:guid',
    //   // '/projectsummary/{searchID}{searchName:(?:/[^/]+)?}', causes controller to be double-loaded
    //   controller: 'ProjectSummaryController',
    //   templateUrl: function () {
    //     if (window.innerWidth < 825) {
    //       return '../app-ds3/search/projectSummary-mobile.partial.html';
    //     }
    //     else {
    //       return '../app-ds3/search/projectSummary.partial.html';
    //     }
    //   },
    //   //"../app-ds3/search/projectSummary.partial.html",
    //   data: { requiresAuth: true }
    // };

    ///////////////////////////////////////////////////////////////////////
    //  Projects
    ///////////////////////////////////////////////////////////////////////
    const recentlyAddedProjectsState = {
      name: "recentlyAddedProjects",
      url: '/recentlyAddedProjects/?createdwithinweeks',
      controller: 'RecentlyAddedProjectsController',
      templateUrl: "../app-ds3/recentlyAddedProjects/recentlyAddedProjects.partial.html",
      //resolve: {
      //  user: [
      //    '$q', 'oidcManager', function($q, oidcManager) {
      //      return oidcManager.manager.getUser(); // <-- already a promise
      //      //return resolveUser("RecentlyAddedProjects", $q, oidcManager);
      //    }
      //  ],,
      data: { requiresAuth: true }
    };

    // // Moved to project-display.states.ts
    // // Using the:
    // //      featues.useNewProjectDisplay key
    // // in environment.ts, this route can be swapped
    // // out for the downgraded ProjectDisplayContainerComponent
    // const searchProjectState = {
    //   name: "search.project",
    //   url: '/project/:projectID/:projectName',
    //   controller: 'ProjectController',
    //   templateUrl: "../app-ds3/search/project.partial.html",
    //   data: { requiresAuth: true }
    // };




    const searchContractAwardSummaryState = {
      name: "search.contractAwardSummary",
      url: '/contractAwardSummary/:guid/:name', //   '/contractawardsummary/{searchID}{searchName:(?:/[^/]+)?}',
      controller: 'ContractAwardSummaryController',
      // templateUrl: "../app-ds3/search/contractAwardSummary.partial.html",
      templateUrl: function () {
        if (window.innerWidth < 825) {
          return '../app-ds3/search/contractAwardSummary-mobile.partial.html';
        }
        else {
          return '../app-ds3/search/contractAwardSummary.partial.html';
        }
      },
      data: { requiresAuth: true }
    };
    const searchContractState = {
      name: "search.contract",
      url: '/contract/:contractID/:contractDescription',
      controller: 'ContractController',
      templateUrl: "../app-ds3/search/contract.partial.html",
      data: { requiresAuth: true }
    };


    ///////////////////////////////////////////////////////////////////////
    //  NotificationCentre and watches
    ///////////////////////////////////////////////////////////////////////
    const notificationCentreState = {
      parent: "app",
      name: 'notificationCentre',
      url: '/notificationcentre',
      controller: 'NotificationCentreController',
      // templateUrl: '../app-ds3/notifications/notificationCentre.partial.html',
      templateUrl: function () {
        return (window.innerWidth < 560)
          ? '../app-ds3/notifications/notificationCentre-mobile.partial.html'
          : '../app-ds3/notifications/notificationCentre.partial.html';
      },

      //resolve: {
      //  user: [
      //    '$q', 'oidcManager', function ($q, oidcManager) {
      //      return oidcManager.manager.getUser(); // <-- already a promise
      //      // return resolveUser("Notification Centre", $q, oidcManager);
      //    }
      //  ],,
      data: { requiresAuth: true }
    };
    const projectWatchState = {
      parent: "app",
      name: 'projectWatch',
      url: '/projectwatch/:guid/:name',
      controller: 'ProjectNotificationSummaryController',
      templateUrl: '../app-ds3/notifications/projectNotificationSummary.partial.html',
      //resolve: {
      //  user: [
      //    '$q', 'oidcManager', function($q, oidcManager) {
      //      return oidcManager.manager.getUser(); // <-- already a promise
      //      //return resolveUser("ProjectNotificationSummary", $q, oidcManager);
      //    }
      //  ],,
      data: { requiresAuth: true }
    };

    // Geographical Summary
    const geographicalSummaryState = {
      parent: "app",
      name: 'geographicalSummary',
      url: '/geographicalSummary',
      controller: 'GeographicalSummaryLoaderController',
      templateUrl: '../app-ds3/geographicalSummary/geographicalSummaryLoader.partial.html',
      data: { requiresAuth: true }
    };



    $stateProvider.state(appState);
    $stateProvider.state(dashboardState);
    $stateProvider.state(unauthorizedForEnvironmentState);
    $stateProvider.state(splashScreenState);

    // ds3 states
    $stateProvider.state(searchState);
    $stateProvider.state(searchForProjectsState);
    $stateProvider.state(searchForProjectsMobileState);

    $stateProvider.state(searchForContractAwardsState);
    $stateProvider.state(searchProjectSummaryState);
    // $stateProvider.state(searchProjectState);
    $stateProvider.state(searchContractAwardSummaryState);
    $stateProvider.state(searchContractState);
    if (!useNewNotifications) {
      $stateProvider.state(notificationCentreState);
      $stateProvider.state(projectWatchState);
    }
    if (!GEOGRAPHICAL_SUMMARY_CONFIG?.enableNewGeographicalSummary) {
      $stateProvider.state(geographicalSummaryState);
    }
    $stateProvider.state(recentlyAddedProjectsState);
  }]);
